const actions = {
  SET_STATE: 'virtualMenu/SET_STATE',
  GET_DATA: 'virtualMenu/GET_DATA',
}

export default actions
